(function () {
    'use strict';
    var ReferenceMaterialBaseCtrl = function (autoInit) {
        return function ($scope, $stateParams, MyChartService, PatientPortalStorageRepository, $modal, LanguageFactory, PersonRepository, PatientAttachmentRepository, toaster, gettext, BrowserService) {
            $scope.loading = false;
            $scope.isModalDisplayed = false;

            var activePatient = PatientPortalStorageRepository.getActivePatient(),
                loginUser = PatientPortalStorageRepository.getLoginUser(),
                activeLanguage = LanguageFactory.getActiveLanguage(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            $scope.model = {
                EducationalMaterial: null,
                LanguageOptions: null,
                ActiveLanguage: {
                    Id: '',
                    Description: ''
                },
                ActivatePatient: activePatient
            };

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                MyChartService
                    .getReferenceMaterial(reportRequestDto)
                    .then(function (data) {
                        auditEducationMaterials(reportRequestDto);
                        $scope.model.EducationalMaterial = _(data.EducationalMaterial).map(function (entry) {
                            return _.assign(entry, {Downloading: false});
                        }).value();

                        $scope.model.LanguageOptions = data.Languages;
                        if (data.Languages && data.Languages.length && activeLanguage) {
                            $scope.model.ActiveLanguage = _.find(data.Languages, {Description: activeLanguage.name}) || data.Languages[0];
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function viewReferenceMaterial(description, eduForms) {
                $scope.isModalDisplayed = true;
                var selectedEduForm = _.find(eduForms, function (form) {
                    return form.Language.Id === $scope.model.ActiveLanguage.Id;
                });
                selectedEduForm = selectedEduForm || eduForms[0];

                var modalConfig = {
                    Title: description,
                    DownloadFileName: description,
                    PatientId: activePatient.id,
                    DocumentId: selectedEduForm.AttachmentId,
                    DocumentLoad: getReferenceMaterial,
                    DocumentDownload: downloadReferenceMaterial,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                });
            }

            function getReferenceMaterial(documentId, requestSettings) {
                return PatientAttachmentRepository.getAttachment(documentId, activePatient.id, requestSettings)
                    .then(function (data) {
                        auditEducationMaterials(reportRequestDto);
                        return data;
                    });
            }

            function downloadReferenceMaterial(documentId) {
                return PatientAttachmentRepository.getAttachmentRetainOriginalFormat(documentId, activePatient.id)
                    .then(function (data) {
                        auditEducationMaterials(reportRequestDto);
                        return data;
                    });
            }

            function updateActiveLanguage(language, mobile) {
                $scope.model.ActiveLanguage = language;
                if (mobile) {
                    $scope.isCollapsed = false;
                }
            }

            function auditEducationMaterials() {
                MyChartService.auditEducationMaterialLogging(reportRequestDto);
            }

            function downloadFormFromModal(documentId) {
                return PersonRepository.getReferenceMaterialAttachment(activePatient.id, documentId)
                    .then(function (data) {
                        auditEducationMaterials(reportRequestDto);
                        return data;
                    });
            }

            function downloadForm(formGroup) {
                formGroup.Downloading = true;
                var selectedEduForm = _.find(formGroup.Forms, function (form) {
                    return form.Language.Id === $scope.model.ActiveLanguage.Id;
                });
                selectedEduForm = selectedEduForm || formGroup.Forms[0];
                return PersonRepository.getReferenceMaterialAttachment(activePatient.id, selectedEduForm.AttachmentId)
                    .then(function (data) {
                        MyChartService.auditEducationMaterialLogging(reportRequestDto);
                        return data;
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred while downloading'));
                    })
                    .finally(function () {
                        formGroup.Downloading = false;
                    });
            }

            $scope.viewReferenceMaterial = viewReferenceMaterial;
            $scope.updateActiveLanguage = updateActiveLanguage;
            $scope.downloadFormFromModal = downloadFormFromModal;
            $scope.getReferenceMaterial = getReferenceMaterial;
            $scope.downloadForm = downloadForm;

            $scope.tileState = {
                isCollapsed: undefined
            };
            $scope.toggleState = function () {
                if ($scope.tileState.isCollapsed === undefined) {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            };

            if (autoInit) {
                initialize();
            }
        };
    };

    var ReferenceMaterialCtrl = new ReferenceMaterialBaseCtrl(true);
    var ReferenceMaterialMobileCtrl = new ReferenceMaterialBaseCtrl(false);

    angular.module('mychart').controller('ReferenceMaterialCtrl',
        ['$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal', 'LanguageFactory', 'PersonRepository', 'PatientAttachmentRepository', 'toaster', 'aprgettext',
        'BrowserService',
            ReferenceMaterialCtrl]);
    angular.module('mychart').controller('ReferenceMaterialMobileCtrl',
        ['$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal', 'LanguageFactory', 'PersonRepository', 'PatientAttachmentRepository', 'toaster', 'aprgettext',
        'BrowserService',
            ReferenceMaterialMobileCtrl]);
})();